
export * from './department-item';
export * from './department-presenter';
export * from './department-breadcrumb-presenter';

import { DepartmentItemComponent } from './department-item';
import { DepartmentPresenterComponent } from './department-presenter';
import { DepartmentBreadcrumbPresenterComponent } from './department-breadcrumb-presenter';


export const DepartmentAtoms = [
    DepartmentItemComponent,
    DepartmentPresenterComponent,
    DepartmentBreadcrumbPresenterComponent
]